if (typeof $.fn.slick !== 'undefined') {
    console.log('custom-slick-carousel.js: Slick is loaded');
} else {
    console.log('custom-slick-carousel.js: Slick is not loaded');
}

$(document).ready(function() {
    var slider = $('#product-slider');

    function initSlick() {
        if (slider.hasClass('slick-initialized')) {
            slider.slick('unslick'); // Destroy existing instance
        }
        slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            adaptiveHeight: true,
            mobileFirst: false,
            autoplaySpeed: 2000,
            autoplay: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 968,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                      autoplay:false,
                    }
                }
            ]
        });
    }

    setTimeout(function() {
    initSlick();
}, 1000);

    $(window).on('resize', function() {
        initSlick();
    });

    if ($(window).width() < 768) {
        $('.slick-slider-container').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,   
            adaptiveHeight: true
        });
    }

    $('#slick-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        adaptiveHeight: true
    });

    $('#slick-slider-test').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        adaptiveHeight: true
    });

    $('.reviews-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        adaptiveHeight: true
    });
});
